// Format an ISO date deterministically in UTC so SSR and client hydration
// produce identical text regardless of the user's timezone.
export const formatDate = (iso: string) => {
  const d = new Date(iso);
  return d.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC",
  });
};
